<template>
    <div>
        <v-color-picker
                v-model="item[changeKey]"
                dot-size="25"
                :swatches="swatches"
                show-swatches
                swatches-max-height="200"
        ></v-color-picker>

        COLOR: {{ item.color }}
    </div>
</template>

<script>

    export default {
        props: {
            changeKey: {
                type: [String],
                required: false,
                default: 'color'
            },
            item:Object
        },
        components: {},
        data() {
            return {
                types: ['hexa', 'rgba'],
                type: 'hexa',
                hex: '#FF00FF',
                hexa: '#FF00FFFF',
                rgba: { r: 255, g: 0, b: 255, a: 1 },
                hsla: { h: 300, s: 1, l: 0.5, a: 1 },
                hsva: { h: 300, s: 1, v: 1, a: 1 },
                swatches: [
                    ['#FF0000', '#AA0000', '#550000'],
                    ['#FFFF00', '#AAAA00', '#555500'],
                    ['#00FF00', '#00AA00', '#005500'],
                    ['#00FFFF', '#00AAAA', '#005555'],
                    ['#0000FF', '#0000AA', '#000055'],
                ],
            }
        },
        methods: {

        },
        watch: {
            'color': function(nv, ov)
            {
                if(this.changeKey !== 'value')
                {
                    this.item.using_image = false;
                    this.item.using_video = false;
                    this.item.parallax = false;
                    this.item.parallax = false;
                    this.item.background_image = '';
                }
            }
        },
        computed: {
            color: {
                get () {
                    return this[this.type]
                },
                set (v) {
                    this[this.type] = v
                },
            },
            showColor () {

                if (typeof this.color === 'string') return this.color;

                return JSON.stringify(Object.keys(this.color).reduce((color, key) => {
                    color[key] = Number(this.color[key].toFixed(2));
                    return color
                }, {}), null, 2);
            },
        },

    }
</script>
